import { render, staticRenderFns } from "./Devoluciones.vue?vue&type=template&id=9630b2fc&scoped=true&"
import script from "./Devoluciones.vue?vue&type=script&lang=js&"
export * from "./Devoluciones.vue?vue&type=script&lang=js&"
import style0 from "./Devoluciones.vue?vue&type=style&index=0&id=9630b2fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9630b2fc",
  null
  
)

export default component.exports